import { subDays } from 'date-fns';
import { validationTypes } from 'components/FormCreator/types';
import { DataType } from 'components/BasicTable/types';

export enum convertSteps {
	DETAILS = 'details',
	REVIEW = 'review',
	COMPLETE = 'complete',
}

export enum convertStepsStatus {
	notStarted = 'notStarted',
	inProgress = 'inProgress',
	pending = 'pending',
	error = 'error',
	completed = 'completed',
}

export enum convertType {
	sell = 'sell',
	buy = 'buy',
}

export interface Convert {
	ccId?: string;
	type: convertType;
	sell_currency?: string;
	buy_currency?: string;
	amount?: number;
	settlement_date?: string;
	conversion_date?: string;
	reference?: string;
	exhange_rate?: number;
	created_date?: string;
	wcStatus: convertStepsStatus;
	companyId?: number;
	optionalDates: string[];
	cutOffTime: any;
}

export interface ConvertData {
	company_id?: number;
	settlement_cut_off_time?: string;
	conversion_date?: string;
	amount?: number;
	fixed_side?: string;
	currency_pair?: string;
	clientBuyCurrency?: string;
	clientSellCurrency?: string;
	clientBuyCurrency_id?: number;
	clientSellCurrency_id?: number;
	cc_buy_amount?: number;
	cc_sell_amount?: number;
	altshulerBuyAmount?: number;
	altshulerSellAmount?: number;
	clientRate?: number;
	core_rate?: number;
	mid_market_rate?: number;
	altshulerRate?: number;
	altshuler_rate?: number;
	deposit_required?: boolean;
	deposit_amount?: number;
	deposit_currency?: string;
	status?: string;
	create_by_contact_id?: number;
	dueDate?: string;
	updatedAt?: string;
	createdAt?: string;
	pendingQuoteId?: number;
	finalRate?: number;
	termAgreement?: boolean;
}

export interface ConversionResponse {
	id?: number;
	company_id?: number;
	settlement_cut_off_time?: string;
	amount?: number;
	fixed_side?: string;
	currency_pair?: string;
	clientBuyCurrency?: string;
	clientSellCurrency?: string;
	clientBuyCurrency_id?: number;
	clientSellCurrency_id?: number;
	ccBuyAmount?: number;
	ccSellAmount?: number;
	altshulerBuyAmount?: number;
	altshulerSellAmount?: number;
	client_rate?: number;
	partner_rate?: number;
	core_rate?: number;
	mid_market_rate?: number;
	altshuler_rate?: number;
	status?: string;
	create_by_contact_id?: number;
	dueDate?: string;
	pendingQuote?: any;
	updatedAt?: string;
	createdAt?: string;
}

export const convertIntialState: Convert = {
	type: convertType.sell,
	wcStatus: convertStepsStatus.notStarted,
	optionalDates: [],
	cutOffTime: null,
};

export const ConvertDetailsSellBuy: (keyof Convert)[] = ['sell_currency', 'buy_currency'];

export const ConvertDetails: (keyof Convert)[] = ['type', 'sell_currency', 'buy_currency', 'amount'];

export const ConvertSchedule: (keyof Convert)[] = ['conversion_date'];

export const ConvertId: keyof Convert = 'ccId';

export const ConvertDefaultSort: keyof Convert = 'type';

export type balanceitem = {
	id?: number;
	companyId?: number;
	currencyId: number;
	amount?: number;
};

/*export const dummyConverts = () => { //todo: remove when real data
    let list:Convert[] = [];
    let i = 20;
    while (i > 0){
        list.push(
            {
                ccId:'udfsf' +i,
                convertName: i % 2 === 0 ? `Individual ${i} Ltd` : `Company ${i} Ltd`,
                country: i % 5 === 0 ? i % 3 === 0 ?'IL' : 'AD' : i % 4 === 0 ? 'CO' : 'WF',
                type: i % 2 ? convertType.INDIVIDUAL : convertType.COMPANY,
                payments: [paymentsTypes.LOCAL,paymentsTypes.PRIORITY],
                convertion_date:String(subDays(new Date(),i)),
                wcStatus:i % 2 === 0 ? i % 3 === 0 ? convertStepsStatus.pending : convertStepsStatus.inProgress : convertStepsStatus.completed,
                bankAccountCountryId:'CO',
                bankAccountHolderName:'Pablo Escobar',
                bankCurrency:'1212',
                city:'Kaly',
                address:'Gringo Bolivard',
                iban:'1234',
                bic:'5678',
            }
        )
        i--;
    }
    return list;
}*/

export const fieldsValidations: { [key in keyof Partial<Convert>]: validationTypes[] } = {
	sell_currency: [validationTypes.requierd],
	buy_currency: [validationTypes.requierd],
	amount: [validationTypes.requierd],
	conversion_date: [validationTypes.requierd],
};
